import { db } from './db';
import type { ActionDefinition, Monster, PlayerCharacter } from '../domain/types';
import { defaultAbilities, emptyModifiers } from '../domain/types';

const id = (value: string) => `seed-${value}`;

const scimitar: ActionDefinition = {
  id: id('scimitar'),
  name: '弯刀',
  type: 'attack',
  section: 'action',
  attackBonus: 4,
  damages: [{ dice: '1d6+2', type: '斩击' }],
};

const goblin: Monster = {
  id: id('goblin'),
  name: '哥布林',
  cr: 0.25,
  types: ['humanoid', 'goblinoid'],
  ac: 15,
  hp: { average: 7, roll: '2d6' },
  speed: { walk: 30 },
  abilities: { ...defaultAbilities(), str: 8, dex: 14, wis: 8 },
  resistances: emptyModifiers(),
  vulnerabilities: emptyModifiers(),
  immunities: emptyModifiers(),
  actions: [scimitar],
};

const fighter: PlayerCharacter = {
  id: id('fighter'),
  name: '艾瑞克',
  ac: 16,
  hpMax: 32,
  hpCurrent: 32,
  abilities: { ...defaultAbilities(), str: 16, dex: 12, con: 14, cha: 12 },
  resistances: emptyModifiers(),
  vulnerabilities: emptyModifiers(),
  immunities: emptyModifiers(),
  actions: [],
  features: '一名经验丰富的战士，忠诚可靠。',
};

export async function seedIfEmpty(): Promise<void> {
  const count = await db.monsters.count();
  if (count > 0) return;
  await db.transaction('rw', db.monsters, db.pcs, db.actions, async () => {
    await db.monsters.put(goblin);
    await db.pcs.put(fighter);
    await db.actions.put(scimitar);
  });
}
